/**
 * TABLOYU EXCEL'DE AÇILAN BİR DOSYAYA ÇEVİRİR — tarayıcıda, sunucuya gitmeden.
 *
 * ── NİÇİN CSV, NİÇİN .xlsx DEĞİL ───────────────────────────────────────────
 * Gerçek bir .xlsx üretmek `exceljs` gerektirir; o paket YALNIZCA sunucu
 * tarafında var ve `CONTRACT.md` web'e yeni bağımlılık eklemeyi yasaklıyor.
 * Kalan iki seçenek: (a) sunucuda rapor üretip Storage'a yazmak, (b) tarayıcıda
 * CSV üretmek. Finans verisi için (b) seçildi:
 *   · Veri ZATEN tarayıcıda ve kullanıcı onu görmeye yetkili (`boss` + financeView).
 *   · Sunucu yolu, finans verisi içeren KALICI bir dosyayı Storage'a bırakırdı.
 *     Bu depo aynı gerekçeyle denetim kaydında kalıcı bağlantı vermiyor
 *     (`reports/auditLog.ts`: "paylaşılabilir bir URL'ye dönüşmemelidir").
 *   · Dışa aktarım ekranda görünenin BİREBİR aynısı olur; ikinci bir sorgu
 *     yoktur, dolayısıyla ekran ile dosya ayrışamaz.
 *
 * ── EXCEL'İN AÇABİLMESİ İÇİN İKİ ŞART ──────────────────────────────────────
 *  1. BOM (﻿). Olmadan Excel dosyayı Windows-1254 sanır ve Türkçe
 *     karakterler bozulur ("Ürün" → "ÃœrÃ¼n").
 *  2. NOKTALI VİRGÜL ayracı. Türkçe Windows'ta Excel'in liste ayracı `;`dir;
 *     virgülle ayrılmış dosyayı TEK SÜTUNA yapıştırır. Ondalık ayracı da virgül
 *     olduğu için zaten virgül kullanılamaz.
 */

/** Excel'in sayı olarak tanıması için Türkçe ondalık: 14791.7 → "14791,70" */
export function csvTutar(kurus: number | null | undefined): string {
  if (kurus === null || kurus === undefined || !Number.isFinite(kurus)) return "";
  return (Math.round(kurus) / 100).toFixed(2).replace(".", ",");
}

/** Sayı alanı; boş değer 0 DEĞİL boş hücre olur. */
export function csvSayi(v: number | null | undefined): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return "";
  return String(v).replace(".", ",");
}

/**
 * Tek hücreyi kaçırır.
 *
 * `;`, tırnak, satır sonu ya da BAŞTA/SONDA boşluk içeren değer tırnaklanır;
 * içindeki tırnak ikilenir (RFC 4180). Baştaki boşluğu da tırnaklıyoruz çünkü
 * Excel onu kırpıp hücreyi kaydırabiliyor.
 */
function hucre(v: string): string {
  const s = v ?? "";
  return /[";\r\n]|^\s|\s$/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Satırları CSV metnine çevirir (BOM dâhil). */
export function csvMetni(basliklar: string[], satirlar: string[][]): string {
  const golge = [basliklar, ...satirlar]
    .map((r) => r.map(hucre).join(";"))
    // \r\n: Excel'in beklediği satır sonu.
    .join("\r\n");
  return "﻿" + golge;
}

/**
 * Dosyayı indirir.
 *
 * `URL.revokeObjectURL` ÇAĞRILIR: çağrılmazsa blob sekme kapanana kadar bellekte
 * kalır ve büyük dışa aktarımlarda birikir.
 */
export function csvIndir(dosyaAdi: string, icerik: string): void {
  const blob = new Blob([icerik], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = dosyaAdi;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** Dosya adına konabilecek güvenli parça: "12.08.2026 – 20.08.2026" → "12-08-2026_20-08-2026" */
export function dosyaParcasi(s: string): string {
  return s
    .replace(/[.\s]/g, "-")
    .replace(/[–—]/g, "_")
    .replace(/[^0-9A-Za-zÇĞİÖŞÜçğıöşü_-]/g, "")
    .replace(/-+/g, "-")
    .replace(/_+/g, "_");
}
